import { observer } from "mobx-react-lite"
import React, { FC, useCallback, useRef, useState } from "react"
import { Appearance, Dimensions, FlatList, ImageStyle, View, ViewStyle } from "react-native"
import { AddMemberForm, AutoImage, Button, JalaIcon, Screen, Text } from "../../../../../components"
// import { useStores } from "../../models"
import { CompositeScreenProps } from "@react-navigation/native"
import { FormikProps, FormikValues } from "formik"
import _ from "lodash"
import { TxKeyPath } from "../../../../../i18n"
import { useStores } from "../../../../../models"
import { goBack } from "../../../../../navigators"
import { color } from "../../../../../theme"
import JalaAnalytic from "../../../../../utils/jala-analytic"

const ROOT: ViewStyle = {
  flexGrow: 1,
}

const BTN_CONTAINER: ViewStyle = {
  paddingHorizontal: 16
}

const FLAT_LIST: ViewStyle = {
  paddingHorizontal: 16
}

const IMG_WRAPPER: ViewStyle = {
  flexDirection: 'row',
  alignItems: 'center'
}

const IMG: ImageStyle = {
  width: 100,
  height: 100
}

const LIST_ACCESS: ViewStyle = {
  flexDirection: 'row',
  marginBottom: 20,
  alignItems: 'center',
}

const ICON_WRAPPER = (checked: boolean): ViewStyle => ({
  backgroundColor: checked ? color.palette.blueSky : color.palette.redLight,
  borderRadius: 50,
  padding: 4,
  maxHeight: 24,
  marginRight: 16
})

const role = [
  // { id: 0, name: 'None' },
  { id: 3, name: 'owner', image: require("./owner.png") },
  { id: 10, name: 'admin', image: require("./person-admin.png") },
  { id: 4, name: 'operator', image: require("./farmer.png") },
  { id: 11, name: 'laboran', image: require("./person-lab.png") },
  { id: 5, name: 'viewer', image: require("./watcher.png") }
];

const setIcon = (type, roles) => {
  const role = roles.toLowerCase();
  const isOwner = role === 'owner';
  const isAdmin = role === 'admin';
  const isOperator = role === 'operator';
  const isWatcher = role === 'viewer';
  const isLaboran = role === 'laboran';
  let iconName = 'check_round';
  if (type === 'first') {
    iconName = isOwner ? 'check_round' : 'delete';
  } else if (type === 'second') {
    iconName = isOwner || isAdmin ? 'check_round' : 'delete';
  } else if (type === 'third') {
    iconName = isOwner || isAdmin || isOperator ? 'check_round' : 'delete';
  } else if (type === 'fourth') {
    iconName = isWatcher ? 'delete' : 'check_round';
  } else if (type === 'fifth') {
    iconName = isLaboran ? 'delete' : 'check_round';
  }
  return iconName;
}

const ListAccess = ({ type, tx, role, colorScheme } : { type?: string, tx?: string, role?: string, colorScheme?: "light" | "dark" }) => {
  const isCheck = setIcon(type, role) === 'check_round';
  const text = `connectedFarm.${_.camelCase(tx)}` as TxKeyPath;
  const windowWidth = Dimensions.get('window').width - 80;
  return (
    <View style={LIST_ACCESS}>
      <View style={ICON_WRAPPER(isCheck)}>
        <JalaIcon name={setIcon(type, role)} color={color.palette.white} size={15} />
      </View>
        <Text preset="body1" tx={text} width={windowWidth} numberOfLines={2} ellipsizeMode="tail" colorScheme={colorScheme} />
    </View>
  )
}

export const Access = ({ role, colorScheme } : { role?: string, colorScheme?: "light" | "dark" }) => (
  <>
    <ListAccess type="fourth" tx="access1" role={role} colorScheme={colorScheme} />
    <ListAccess type="sixth" tx="access2" role={role} colorScheme={colorScheme} />
    <ListAccess type="fifth" tx="access3" role={role} colorScheme={colorScheme} />
    <ListAccess type="third" tx="access4" role={role} colorScheme={colorScheme} />
    <ListAccess type="third" tx="access5" role={role} colorScheme={colorScheme} />
    <ListAccess type="second" tx="access6" role={role} colorScheme={colorScheme} />
    <ListAccess type="second" tx="access7" role={role} colorScheme={colorScheme} />
    <ListAccess type="first" tx="access8" role={role} colorScheme={colorScheme} />
    <ListAccess type="first" tx="access9" role={role} colorScheme={colorScheme} />
  </>
)

export const AddMemberScreen: FC<{ colorScheme?: "light" | "dark", route?: any } & CompositeScreenProps<any, any>> = observer(function AddMemberScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme(), route: { params: { data = {} }} } = props

  const [ isError, setIsError ] = useState<boolean>(true);


  // Pull in one of our MST stores
  const { farmStore, farmStore: { loading } } = useStores();

  const addMemberForm = useRef<FormikProps<FormikValues>>()
  const addMemberFormRef = useCallback((node) => {
    addMemberForm.current = node;
    if (addMemberForm.current) setIsError(!(addMemberForm.current.dirty && addMemberForm.current.isValid))
  }, [])

  const onSubmit = (form) => {

    // const forms = { ...form, farmId: data.farm.id }
    const param = { user_id: form.user_id, email: form.email, role_id: form.role_id, _method: 'PUT' }
    const forms = { ...form, param, farmId: data.farm_id }

    if (form.route === 'add') farmStore.addFarmProfile(forms).then(() => {
      goBack('Profile.Stack')
      goBack('Profile.Stack')
    });
    else farmStore.updateFarmProfile(forms).then(() => {
      JalaAnalytic.log('Mobile app: farm access - edit access', forms);
      goBack('Profile.Stack')
      goBack('Profile.Stack')
    })
  }

  const handleSubmit = (event) => {
    if (addMemberForm.current) addMemberForm.current.handleSubmit(event)
  }


  const ProfileInfo = (item) => {
    const { name, image } = item.item;
    return (
    <View>
      <View style={IMG_WRAPPER}>
        <AutoImage source={image} style={IMG} />
        <Text preset="title3" tx={`connectedFarm.${name}` as TxKeyPath} colorScheme={colorScheme} />
      </View>
      <Access role={name} colorScheme={colorScheme} />
    </View>
  )}

  const RoleList = () => (
    <View style={FLAT_LIST}>
      <Text preset="title3" tx="connectedFarm.info" colorScheme={colorScheme} />
      <FlatList data={role} keyExtractor={(item) => String(item.id)} renderItem={ProfileInfo} />
    </View>
  )

  return (
    <Screen
      style={ROOT}
      preset="scroll"
      colorScheme={colorScheme}
      backgroundBar={color.primary}
      statusBar="light-content"
    >
      <AddMemberForm
        initialValues={data.route === 'edit' ? { ...data, email: data.user.email } : {}}
        colorScheme={colorScheme}
        innerRef={addMemberFormRef}
        onSubmit={onSubmit}
      />
      <RoleList />
      <View style={BTN_CONTAINER}>
        <Button testID="jala:id/save-input-button" tx="save" colorScheme={colorScheme} loading={loading} disabled={isError} onPress={handleSubmit} />
      </View>
    </Screen>
  )
})
